const LOCALE_COUNTRIES = {
  AUSTRALIA: 'Australia',
  BRAZIL: 'Brazil',
  CANADA: 'Canada',
  FRANCE: 'France',
  GERMANY: 'Germany',
  ITALY: 'Italy',
  MEXICO: 'Mexico',
  NETHERLANDS: 'Netherlands',
  SPAIN: 'Spain',
  UNITED_KINGDOM: 'United Kingdom',
  UNITED_STATES: 'United States',
  JAPAN: 'Japan',
  SINGAPORE: 'Singapore',
  INDIA: 'India',
};

module.exports = LOCALE_COUNTRIES;
